import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {isMobile} from "react-device-detect"
import Helmet from 'react-helmet'
import {Links} from '../routes/PathLink'
//import {useAuth} from '../provider/AuthProvider'

import {
  useSectorCompaniesQuery
} from '../data/sector-details';


import { Table } from "../components/ui/table";
//import Pagination from '../components/ui/pagination';
import { Pagination, Select } from "antd";
import { t } from "i18next";
import { amount_format } from "../components/config/Common";
import Breadcrumb  from "../components/Breadcrumb";
import CompanyTable  from "../components/CompanyTable";
import {APP_URL, APP_NAME} from 'components/config/Common'
//import { useLocation } from "react-router-dom";
import Seo from 'components/seo/seo'

import RelatedScreens from './related-screens/related-screens'

const SectorDetails = () => {	
	const navigate = useNavigate();
	
	const [product_slug, setProduct_slug] = useState('');	
	const [cat_arr, setCatArr] = useState([])	
	const [canonicalurl , setCanonicalurl] = useState('');	
	const [description, setDescription] = useState('');
	const {slug} = useParams()
	//const { isUser, loginToken } = useAuth();
	//const { addCartItem, cartItem, updateItemQty, deleteCartItem, checkItemInCart, itemCartQty } = useCart();
	
	const [metaTitle, setMetaTitle] = useState('')
	const [metaDesc, setMetaDesc] = useState('')
	const [user_type, setUser_type] = useState('');
  const [snipetData, setSnipetData] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_PAGE_LIMIT);
  const [orderBy, setOrder] = useState('created_at');
  const [sortedBy, setColumn] = useState('desc');
  //const [sector_tree, setSector_tree] = useState([]);
  
  // SORTING
  const [sortInfo, setSortInfo] = useState({ key: null, order: null });
  const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
  
  /* useEffect(() => {
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    console.log("status_p",status_p);
  }, [sector_tree]); */

  const onPagination = (current) => {
    console.log("current Page",current);
    setPage(current);
  }

  const onPageSize = (value) => {
    setPageSize(value);
    setPage(1);
  }
    
  
	//console.log("slug",slug);
	const {
		product,
    sectorDetails,
    sector_tree,
    paginatorInfo,
		isLoading,
		error,
	} = useSectorCompaniesQuery({ 
    slug,
    limit: pageSize,
    page,    
    orderBy,
    sortedBy,
	});

  
	useEffect(() => {
    const title = generateSectorMetaTitle(sector_tree);
    const description = generateSectorMetaDescription(sector_tree);
    setMetaTitle(title);
    setMetaDesc(description);
    //setSector_tree(sector_tree);
    //console.log("sector_tree in useEffect: ", sector_tree);
  }, [sector_tree]);

const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

/* const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Sector`,
    link:`${process.env.REACT_APP_URL}${Links.SECTORS}`
  },
  {
    name:`${sectorDetails?.name}`,
    link:null
  },
] */

  

  //console.log('screenProduct=====', screenProduct)

function generateSectorMetaTitle(sectorTree) {
  sectorTree = sectorTree || [];
  if (sectorTree.length === 0) {
    return 'Sectors | Market, Charts & Fundamentals';
  }
  const last = sectorTree[sectorTree?.length - 1]; // current sector
  const parents = sectorTree.slice(0, -1).map(s => s.name).join(" › ");

  return parents
    ? `${last.name} Stocks – ${parents} | Market, Charts & Fundamentals`
    : `${last.name} Stocks | Market, Charts & Fundamentals`;
}

function generateSectorMetaDescription(sectorTree) {
  sectorTree = sectorTree || [];
  if (sectorTree.length === 0) {
    return 'Discover various market sectors and explore their details on our platform.';
  }
  const last = sectorTree[sectorTree?.length - 1];
  const fullPath = sectorTree.map(s => s.name).join(" › ");

  return `Explore ${last.name} stocks under ${fullPath}. Get live prices, financials, ratios, charts, and performance of top companies in this sector.`;
}


const buildBreadcrumb = (sectorTree) => {

  const baseUrl = process.env.REACT_APP_URL;

  const breadcrumb = [
    {
      name: "Home",
      link: `${baseUrl}`,
    },
    {
      name: "Sectors",
      link: `${baseUrl}${Links.SECTORS}`,
    },
  ];

  sectorTree?.forEach((item, index) => {
    const isLast = index === sectorTree.length - 1;

    breadcrumb.push({
      name: item.name,
      link: isLast
        ? null
        : `${baseUrl}${Links.SECTORS}/${item.slug}`,
    });
  });

  return breadcrumb;
};

function generateBreadcrumbSchema(breadcrumb) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumb.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.link || window.location.href,
    })),
  };
}

const breadcrumb = buildBreadcrumb(sector_tree);
const schema = generateBreadcrumbSchema(breadcrumb);

//console.log("breadcrumb:", schema);

	return (
		<>
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
    <Seo 
            title={`${metaTitle} - ${APP_NAME}`}
            desc={metaDesc && metaDesc.substring(0, 200)}
            url={`${APP_URL}/sectors/${slug}`}
          />
		<Header  />        
        <div className="space-y-5 px-5 lg:px-8">
          {sectorDetails && <Breadcrumb breadcrumb={breadcrumb} />}
            <section className="bg-white shadow-sm rounded-xl p-5">
                <h2 className="text-2xl">{sectorDetails?.name}</h2>
                <div className="mt-3">{metaDesc}</div>
                <CompanyTable 
                    data={product} 
                    pageSize={pageSize} 
                    isLoading={isLoading} 
                    paginatorInfo={paginatorInfo}
                    totalPages={totalPages}
                    onPagination={onPagination}
                    onPageSize={onPageSize}
                />
    
            </section>
            <RelatedScreens />
        </div>
       
		<Footer />
		
		
		</>
		);
};

export default SectorDetails;